import { mapState, mapActions, mapMutations } from 'vuex'
import MainMap from '@/components/main-map/main-map.vue'
import ShiftList from '@/components/shifts-list/shifts-list.vue'
import { shiftStatuses } from '@/const'
import IcCalendar from '@/assets/svg/ic-calendar.svg?inline'

const updateTime = 10000

export default {
  name: 'Couriers',
  components: {
    MainMap,
    ShiftList,
    IcCalendar
  },
  static() {
    return {
      shiftStatuses
    }
  },
  data() {
    return {
      colShiftsSectors: ['ready', 'review', 'delivery', 'ontheway'],
      colShiftsSectorsEqual: [
        {
          name: 'ready',
          sectorChild: 'pause'
        }
      ],
      funcShiftSectors: ['close', 'open', 'gain', 'rest_couriers'],
      openedSectors: ['ready', 'review', 'delivery', 'ontheway'],

      shiftInfo: null,
      timeoutUpdate: null,
      isPauseOpen: false
    }
  },
  computed: {
    ...mapState({
      editedRouteTask: state => state.routeTasks.editedRouteTask,
      loading: state => state.pageLoader.loading,
      isEqualSharesCol() {
        return colSectorKey => {
          const sectorEqual = this.colShiftsSectorsEqual.find(sectorInfo => {
            return sectorInfo.name === colSectorKey
          })
          if (sectorEqual) {
            return !!this.openedSectors.find(s => s === sectorEqual.sectorChild)
          }
          return false
        }
      }
    })
  },
  async mounted() {
    await this.setShiftInfo()
  },
  beforeDestroy() {
    this.cancelShiftReq()
  },
  methods: {
    ...mapActions({
      getShifts: 'couriers/getShifts',
      cancelGetShifts: 'couriers/cancelGetShifts',
      setActionShift: 'couriers/setActionShift',
      createNewShift: 'couriers/createNewShift',
      getRouteTaskById: 'routeTasks/getRouteTaskById'
    }),
    ...mapMutations({
      setLoading: 'pageLoader/SET_LOADING',
      addServerError: 'serverErrors/ADD_ERROR'
    }),
    async getShiftsInfo() {
      const res = await this.getShifts()
      this.shiftInfo = res
    },
    async onGainChanged() {
      await this.cancelShiftReq()
      await this.setShiftInfo()
    },
    /**
     * data = {
     *    shift_id,
     *    action,
     *    ...
     * }
     * 
     */
    async onSetActionShift(data) {
      await this.cancelShiftReq()
      try {
        await this.setActionShift(data)
      } finally {
        await this.setShiftInfo()
      }
    },
    async onCreateNewShift(data) {
      await this.cancelShiftReq()
      try {
        await this.createNewShift(data)
      } finally {
        await this.setShiftInfo()
      }
    },
    async onCourierShiftChange() {
      await this.cancelShiftReq()
      await this.setShiftInfo()
    },
    async cancelShiftReq() {
      clearTimeout(this.timeoutUpdate)
      this.timeoutUpdate = null
      await this.cancelGetShifts()
    },
    async setShiftInfo() {
      try {
        this.setLoading(true)
        await this.getShiftsInfo()
        this.timeoutUpdate = setTimeout(() => {
          this.updateInfo()
        }, updateTime)
      } finally {
        this.setLoading(false)
      }
      
    },
    async updateInfo() {
      await this.getShiftsInfo()
      this.timeoutUpdate = setTimeout(() => {
        this.updateInfo()
      }, updateTime)
    },
    async getRouteTask(routeTaskId) {
      try {
        this.setLoading(true)
        await this.getRouteTaskById(routeTaskId)
      } finally {
        this.setLoading(false)
      }
    },
    onShiftListToggle(event, sectorKey, sectorsToClose) {
      if (event) {
        if (sectorsToClose) {
          const sectorClose = this.openedSectors.find(s => sectorsToClose.indexOf(s) !== -1)
          if (sectorClose) {
            this.openedSectors = this.openedSectors.filter(s => s !== sectorClose)
          }
        }
        if (!this.openedSectors.find(s => s === sectorKey)) {
          this.openedSectors.push(sectorKey)
        }
      } else {
        this.openedSectors = this.openedSectors.filter(s => s !== sectorKey)
      }
    },
    onCourierChanged(event, sectorKey) {
      if (this.shiftInfo) {
        /**
         * за источник истины возмем courier_id
         */
        const findedShift = this.shiftInfo[sectorKey].find(s => s.courier_id == event.courier_id) 
        if (findedShift) {
          Object.assign(findedShift, event)
        }
      }
    }
  }
}
